module.exports = __webpack_public_path__ + "assets/img/clerk-title.4c12d45e.svg";